/**
 * The eight tiles' pictures: one line each, in the tile's own colour. The
 * icon name is the preset row's `icon`, so the admin can reassign one
 * without a deploy; an unknown name draws the notes.
 */
const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  viewBox: '0 0 24 24',
  'aria-hidden': true,
} as const;

const COLOURS: Record<string, string> = {
  notes: 'text-[#a56cf5]',
  flame: 'text-[#ff5a3c]',
  gem: 'text-[#4aa8ff]',
  cassette: 'text-[#ff9a3c]',
  leaf: 'text-[#33e58a]',
  orbit: 'text-[#2fd4c8]',
  film: 'text-[#f5c84a]',
  burst: 'text-[#ff5ab8]',
};

export function PresetGlyph({ icon, className = '' }: { icon: string; className?: string }) {
  const colour = COLOURS[icon] ?? COLOURS.notes;
  const cls = `${className} ${colour}`;

  switch (icon) {
    case 'flame':
      return (
        <svg {...stroke} className={cls}>
          <path d="M12 3c1 3 5 5 5 10a5 5 0 0 1-10 0c0-2 1-3 2-4 0 2 1 3 2 3 1-2 0-6 1-9Z" />
        </svg>
      );
    case 'gem':
      return (
        <svg {...stroke} className={cls}>
          <path d="M7 4h10l4 5-9 11L3 9l4-5Z" />
          <path d="M3 9h18M9 4l3 5 3-5M9 9l3 11 3-11" />
        </svg>
      );
    case 'cassette':
      return (
        <svg {...stroke} className={cls}>
          <rect x="3" y="6" width="18" height="12" rx="2" />
          <circle cx="8.5" cy="12" r="2" />
          <circle cx="15.5" cy="12" r="2" />
          <path d="M7 18l1.5-3h7l1.5 3" />
        </svg>
      );
    case 'leaf':
      return (
        <svg {...stroke} className={cls}>
          <path d="M5 19c0-8 5-13 14-14 0 9-5 14-14 14Z" />
          <path d="M5 19c3-4 6-7 10-9" />
        </svg>
      );
    case 'orbit':
      return (
        <svg {...stroke} className={cls}>
          <circle cx="12" cy="12" r="4" />
          <ellipse cx="12" cy="12" rx="9" ry="3.5" transform="rotate(-25 12 12)" />
          <circle cx="19" cy="8" r="1" fill="currentColor" />
        </svg>
      );
    case 'film':
      return (
        <svg {...stroke} className={cls}>
          <circle cx="12" cy="12" r="8" />
          <circle cx="12" cy="8" r="1.4" />
          <circle cx="12" cy="16" r="1.4" />
          <circle cx="8" cy="12" r="1.4" />
          <circle cx="16" cy="12" r="1.4" />
          <path d="M12 20h8" />
        </svg>
      );
    case 'burst':
      return (
        <svg {...stroke} className={cls}>
          <path d="M12 3l2 5 5-2-2 5 5 2-5 2 2 5-5-2-2 5-2-5-5 2 2-5-5-2 5-2-2-5 5 2 2-5Z" />
        </svg>
      );
    default:
      return (
        <svg {...stroke} className={cls}>
          <path d="M9 18V6l10-2v12" />
          <circle cx="6.5" cy="18" r="2.5" />
          <circle cx="16.5" cy="16" r="2.5" />
        </svg>
      );
  }
}
